import { render, staticRenderFns } from "./PaymentDetail.vue?vue&type=template&id=4e5e78f5"
import script from "../../controllers/payment/payment-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment/payment-detail.js?vue&type=script&lang=js&external"
import style0 from "./PaymentDetail.vue?vue&type=style&index=0&id=4e5e78f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports